export default __webpack_public_path__ + "static/media/naturebible1.1fe0c7b6.jpg";